import {Controller} from '@hotwired/stimulus';

/**
 * Gère un bloc d'offres sur la page "liste des offres"
 */
export default class extends Controller {
  static targets = ['priceTypeSwitch'];
  static values = {
    // monthly ou yearly
    priceType: String,
    priceTypeUrls: Object,
  };

  connect() {
  }

  priceTypeSwitchTargetConnected(element) {
    element.addEventListener('change', this.togglePriceType.bind(this));
  }

  togglePriceType(event) {
    this.priceTypeValue = event.target.checked ? 'yearly' : 'monthly';
  }

  priceTypeValueChanged(value, previousValue) {
    this.dispatch('price-type-changed', {
      detail: {
        priceType: value,
      },
    });

    if (previousValue) { // else c'est l'init avec les infos côté serveur, donc pas besoin de re set côté serveur
      fetch(this.priceTypeUrlsValue[value]);
    }
  }
}
